import {Alert, Button, Box, AlertTitle} from '@mui/material'
import styled from '@emotion/styled'
import Typography from '@mui/material/Typography'

const systemTypographyFamily = {
  Sans: '"Open Sans", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
}
export const StyledAlert = styled(Alert)(({theme}) => ({
  fontFamily: systemTypographyFamily,
  border: `1px solid ${theme.palette.hpAccentOrange}`
}))

export const StyledAlertTitle = styled(AlertTitle)(({theme}) => ({
  color: theme.palette.hpBlack,
  marginTop: '4px'
}))

export const StyledListTypography = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.h6.fontSize,
  fontFamily: systemTypographyFamily,
  color: theme.palette.hpBlack,
  marginTop: '2px'
}))

export const StyledLink = styled('a')(({theme}) => ({
  color: theme.palette.hpPrimaryDark,
  textDecoration: 'underline'
}))

export const StyledListButton = styled(Button)(({theme}) => ({
  textTransform: 'none',
  textDecoration: 'underline',
  backgroundColor: 'inherit',
  color: theme.palette.hpPrimaryDark,
  fontStyle: 'italic',
  fontSize: theme.typography.h6.fontSize,
  fontFamily: systemTypographyFamily,
  '&:hover': {backgroundColor: 'inherit'},
  marginLeft: '-6px'
}))

export const MainBox = styled(Box)(() => ({
  position: 'block',
  marginLeft: '0px'
}))
